import { render, staticRenderFns } from "./DictionarySelect.vue?vue&type=template&id=7e01fa3c&"
import script from "./DictionarySelect.vue?vue&type=script&lang=ts&"
export * from "./DictionarySelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports